import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectSearchComponent } from './select-search.component';
import { AutofocusDirective } from './select-search.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [SelectSearchComponent, AutofocusDirective],
    exports: [SelectSearchComponent],
    providers: []
})

export class SelectSearchModule { }
